import React from 'react';
import { graphql } from 'gatsby';

import { Footer as FooterDS } from '@solublestudio/soluble-design-system';
import { useTranslate } from '@solublestudio/gatsby-theme-soluble-source';

interface FooterProps {
    [key: string]: any;
}

export default function Footer({
    data,
    layoutProps = {},
    alternateLanguages,
}: FooterProps) {
    const { links, iconLinkHref } = layoutProps;
    const _ = useTranslate();

    const contactLink = data?.contactLink?.links?.[0] ?? null;

    return (
        <FooterDS
            text={_['footer.text'].text}
            copyright={_['footer.copyright'].text}
            {...(!!iconLinkHref && { iconLinkHref })}
            contactLink={!layoutProps?.hideContactLink ? contactLink : null}
            mainLinks={
                links
                    ? links.length
                        ? {
                              title: data.mainLinks?.title || '',
                              links,
                          }
                        : null
                    : data.mainLinks
            }
            socialLinks={data.socialLinks}
            newsletterLinks={data.newsletterLinks}
            hiringLinks={data.hiringLinks}
            legalLinks={
                data.legalLinks?.links?.length ? data.legalLinks.links : []
            }
            alternateLanguagesTitle={_['footer.language'].text}
            alternateLanguages={alternateLanguages}
            {...layoutProps}
        />
    );
}

export const query = graphql`
    fragment Link on Link {
        title
        links: childLinks {
            href: slug
            children: label
        }
    }

    query ($language: String) {
        contactLink: link(
            label: { eq: "_contact" }
            templateKey: { eq: "_link-footer" }
            parentId: { eq: null }
            language: { eq: $language }
        ) {
            ...Link
        }
        mainLinks: link(
            label: { glob: "_main:*" }
            templateKey: { eq: "_link-footer" }
            parentId: { eq: null }
            language: { eq: $language }
        ) {
            ...Link
        }
        socialLinks: link(
            label: { glob: "_social:*" }
            templateKey: { eq: "_link-footer" }
            parentId: { eq: null }
            language: { eq: $language }
        ) {
            ...Link
        }
        newsletterLinks: link(
            label: { glob: "_newsletter:*" }
            templateKey: { eq: "_link-footer" }
            parentId: { eq: null }
            language: { eq: $language }
        ) {
            ...Link
        }
        hiringLinks: link(
            label: { glob: "_hiring:*" }
            templateKey: { eq: "_link-footer" }
            parentId: { eq: null }
            language: { eq: $language }
        ) {
            ...Link
        }
        legalLinks: link(
            label: { eq: "_legal" }
            templateKey: { eq: "_link-footer" }
            parentId: { eq: null }
            language: { eq: $language }
        ) {
            ...Link
        }
    }
`;
